import { createContext } from "react";

export const RequestLoader = createContext({});
export const ToastContext = createContext({});
export const MetaHandler = createContext({
  title: "Lumi Merchant Loyalty",
  description: "Lumi Merchant Loyalty",
});
